import React, { FC, useEffect } from 'react'
import StoreLocale, { ConnectorProps as StoreLocaleProps } from 'connectors/StoreLocale'
import PreferenceStoreLocaleAlert, { MODAL_NAME } from 'components/Preferences/Alert/StoreLocale'
import debounce from 'lib/debounce'
import useModal from 'hooks/useModal'
import { getBrowserStoreLocale } from 'lib/storeLocale/client'

const modalDebounce = debounce()

type StoreLocaleAlertProps = StoreLocaleProps

const StoreLocaleAlert: FC<StoreLocaleAlertProps> = (props) => {
  const { isClientReady, userPreferencesStoreLocale, userPreferencesLocaleConfirmed } = props
  const { showModalWithData } = useModal()

  useEffect(() => {
    // isClientReady => User `all-client-data` is loaded
    if (isClientReady) {
      const browserStoreLocale = getBrowserStoreLocale()
      // We need to handle Issue with the BROWSER
      const areStoreLocalesDifferent = browserStoreLocale !== userPreferencesStoreLocale
      if (!userPreferencesLocaleConfirmed || areStoreLocalesDifferent) {
        modalDebounce(
          () =>
            showModalWithData(MODAL_NAME, {
              requiresConfirmation: true,
            }),
          2000
        ) // Open Modal in 2 Seconds
      } else {
        modalDebounce(() => null) // Clear Initial Modal Call
      }
    }
  }, [userPreferencesLocaleConfirmed, isClientReady])

  return <PreferenceStoreLocaleAlert />
}

export default StoreLocale(StoreLocaleAlert)
